import classNames from "classnames";

export default function Button({
	children,
	type = "button",
	onClick,
	size,
	primary,
	secondary,
	success,
	warning,
	danger,
	outline,
	rounded,
	className,
	...props
}) {
	const classes = classNames(
		"px-4 py-2 border text-center transition duration-300 ease-in-out w-full",
		{
			// Colors
			"border-blue-500 bg-blue-500 text-white": primary && !outline,
			"border-gray-900 bg-gray-900 text-white": secondary && !outline,
			"border-green-500 bg-green-500 text-white": success && !outline,
			"border-yellow-400 bg-yellow-400 text-white": warning && !outline,
			"border-red-500 bg-red-500 text-white": danger && !outline,

			// Outline variants
			"bg-white": outline,
			"text-blue-500 border-blue-500": outline && primary,
			"text-gray-900 border-gray-900": outline && secondary,
			"text-green-500 border-green-500": outline && success,
			"text-yellow-400 border-yellow-400": outline && warning,
			"text-red-500 border-red-500": outline && danger,

			// Rounded styles
			"rounded-full": rounded,
		},
		props.className // Additional classes passed via props
	);

	return (
		<button type={type} onClick={onClick} className={classes} {...props}>
			{children}
		</button>
	);
}

// Default props
Button.defaultProps = {
	type: "button",
};

Button.propTypes = {
	checkVariationValue: ({ primary, secondary, success, warning, danger }) => {
		const count =
			Number(!!primary) +
			Number(!!secondary) +
			Number(!!warning) +
			Number(!!success) +
			Number(!!danger);

		if (count > 1) {
			return new Error(
				"Only one of primary, secondary, success, warning, danger can be true"
			);
		}
	},
};
